// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2R2Xl","colCheckbox":"styles_colCheckbox__5Bn2Y"};